/** Lazy paper.js project bootstrap.
 *
 *  Multiple image-editor libs use paper.js for geometric ops
 *  (boolean ops in `path-ops.ts`, raster-to-vector simplify in
 *  `vector-mask.ts`). Each one needs a paper project to attach
 *  paths to. paper.setup is idempotent but allocates internal
 *  state; we want exactly one call per process across all
 *  consumers. This shared helper centralizes that — adding a
 *  third consumer means importing this; no need to add another
 *  copy of the init flag + setup call.
 *
 *  The `paper-core` entry point is used (not `paper`) so module
 *  load doesn't try to attach to a canvas — happy-dom returns
 *  null from getContext, which crashes paper's full module init.
 *  paper-core skips the canvas/rendering layer; set ops work
 *  entirely off path data. Tests still install a Proxy stub at
 *  HTMLCanvasElement.prototype for paper's internal canvas
 *  creation (see `path-ops.test.ts` for the pattern); this
 *  module just makes sure setup runs exactly once. */

import paper from 'paper/dist/paper-core';

let initialized = false;

/** Initialize paper's global project the first time any consumer
 *  needs it. Idempotent. The 1×1 size is irrelevant — paper just
 *  needs a project for path attachment; we never render. */
export function ensurePaperInitialized(): void {
  if (initialized) return;
  paper.setup(new paper.Size(1, 1));
  initialized = true;
}
